import { section } from '@/glow';
import { AnimateInlineFeatures } from '@/lib/animation';

section('inline-features', {
  onLoad() {
    this.AnimateInlineFeatures = AnimateInlineFeatures(this.container);
  },

  onUnload() {
    this.AnimateInlineFeatures?.disconnect();
  }
});
